import React, { ReactNode, useCallback } from 'react'
import { Modal } from '@woorcs/design-system'
import { useNavigate } from 'react-router'
import { Location } from 'history'

export interface ModalRouteProps {
  prevLocation: Location
  children: ReactNode
}

export const ModalRoute = ({ prevLocation, children }: ModalRouteProps) => {
  const navigate = useNavigate()

  const handleVisibilityChange = useCallback(
    (visible: boolean) => {
      if (!visible) {
        navigate(prevLocation.pathname, { replace: true })
      }
    },
    [navigate, prevLocation.pathname]
  )

  return (
    <Modal setOpen={handleVisibilityChange} defaultOpen>
      {children}
    </Modal>
  )
}
